import Button from '@axa-japan/design-system-react/Button';
import Heading from '@axa-japan/design-system-react/Heading';
import { ArrowIcon } from '@axa-japan/design-system-react/Icons';
import Text from '@axa-japan/design-system-react/Text';
import guide1 from '../assets/illustration_guide1.svg';
import guide2 from '../assets/illustration_guide2.svg';
import guide3 from '../assets/illustration_guide3.svg';
import guide4 from '../assets/illustration_guide4.svg';
import guide5 from '../assets/illustration_guide5.svg';
import guide6 from '../assets/illustration_guide6.svg';
import guide7 from '../assets/illustration_guide7.svg';
import guide8 from '../assets/illustration_guide8.svg';

interface IllustrationGuideProps {
  onNext: () => void;
  onBack: () => void;
}
const IllustrationGuidePage: React.FC<IllustrationGuideProps> = ({ onNext, onBack }) => {
  return (
    <div>
      <Heading as="h1">撮影時の注意</Heading>
      <Text>記載内容がはっきり読めるよう、書類全体を写してください。</Text>
      <div className="flex w-full justify-center mt-10">
        <div className="grid grid-cols-8 gap-6  w-full lg:w-4/5">
          <div className="col-span-2">
            <img src={guide1} alt="正しい撮影例1" className="w-full mb-2" />
            <Text>
              {'縦向きの帳票は寝かせて'}
              <span className="font-bold">画面いっぱいに</span>
              {'撮影してください'}
            </Text>
          </div>
          <div className="col-span-2">
            <img src={guide2} alt="正しい撮影例2" className="w-full mb-2" />
            <Text>
              {'横向きの帳票はそのまま'}
              <span className="font-bold">画面いっぱいに</span>
              {'撮影してください'}
            </Text>
          </div>
          <div className="col-span-2">
            <img src={guide3} alt="正しい撮影例3" className="w-full mb-2" />
            <Text>
              {'保険者番号・被保険者等記号・番号（バーコード含む）は'}
              <span className="font-bold">マスキングまたは付箋等で隠して撮影</span>
              {'してください'}
            </Text>
          </div>
          <div className="col-span-2">
            <img src={guide4} alt="正しい撮影例4" className="w-full mb-2" />
            <Text>
              {'折りたたまれた書類は'}
              <span className="font-bold">まっすぐに伸ばして</span>
              {'撮影してください'}
            </Text>
          </div>
          <div className="col-span-2">
            <img src={guide5} alt="正しい撮影例5" className="w-full mb-2" />
            <Text>
              <span className="font-bold">明るすぎ・暗すぎない</span>
              {'ように、'}
              <span className="font-bold">影が映らない</span>
              {'ように撮影してください'}
            </Text>
          </div>
          <div className="col-span-2">
            <img src={guide6} alt="正しい撮影例6" className="w-full mb-2" />

            <Text>
              {'書類の一部が'}
              <span className="font-bold">隠れたり欠けたりしない</span>
              {'ように撮影してください'}
            </Text>
          </div>
          <div className="col-span-2">
            <img src={guide7} alt="正しい撮影例7" className="w-full mb-2" />
            <Text>不要な書類が一緒に写らないようにしてください</Text>
          </div>
          <div className="col-span-2">
            <img src={guide8} alt="正しい撮影例8" className="w-full mb-2" />
            <Text>
              {'書類は'}
              <span className="font-bold">真上からまっすぐに撮影</span>
              {'してください'}
            </Text>
          </div>
        </div>
      </div>

      <div className="flex justify-center gap-3 mt-10">
        <div className="w-80">
          <Button type="button" variant="outlined" onClick={onBack} fullWidth icon={<ArrowIcon rotation="180" />} iconPosition="left">
            戻る
          </Button>
        </div>

        <div className="w-80">
          <Button onClick={onNext} fullWidth icon={<ArrowIcon />}>
            書類アップロードに進む
          </Button>
        </div>
      </div>
    </div>
  );
};

export default IllustrationGuidePage;
